import { render } from "./MenuDropdown.vue?vue&type=template&id=51f27a7c&scoped=true"
import script from "./MenuDropdown.vue?vue&type=script&lang=js"
export * from "./MenuDropdown.vue?vue&type=script&lang=js"

import "./MenuDropdown.vue?vue&type=style&index=0&id=51f27a7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f27a7c"]])

export default __exports__